import Swal from 'sweetalert2';
import { i18n } from '../i18n';

export class ItiMessageService {

    public TypeSuccess = 'success';
    public TypeError = 'error';
    public TypeWarning = 'warning';
    public TypeInfo = 'info';
    public TypeQuestion: any = 'question';

    public PositionTop = 'top';
    public PositionTopStart = 'top-start';
    public PositionTopEnd = 'top-end';
    public PositionCenter = 'center';
    public PositionCenterStart = 'center-start';
    public PositionCenterEnd = 'center-end';
    public PositionBottom = 'bottom';
    public PositionBottomStart = 'bottom-start';
    public PositionBottomEnd = 'bottom-end';

    protected defaultTimeout = 3000;
    protected customClass = '';
    protected animation = true;
    protected allowOutsideClick = false;
    protected allowEscapeKey = true;
    protected allowEscapeKeyOnLoading = false;

    public setDefaultTimeout(defaultTimeout: number) {
      this.defaultTimeout = defaultTimeout;
    }

    public setCustomClass(customClass: string) {
      this.customClass = customClass;
    }

    public setAnimation(animation: boolean) {
      this.animation = animation;
    }

    public setAllowOutsideClick(allowOutsideClick: boolean) {
      this.allowOutsideClick = allowOutsideClick;
    }

    public setAllowEscapeKey(allowEscapeKey: boolean) {
      this.allowEscapeKey = allowEscapeKey;
    }

    public setAllowEscapeKeyOnLoading(allowEscapeKeyOnLoading: boolean) {
      this.allowEscapeKeyOnLoading = allowEscapeKeyOnLoading;
    }


    // Aviso flotante que desaparece solo tras un tiempo
    public toast(
      texto: string, tipo: any = this.TypeSuccess, timeout: number = this.defaultTimeout,
      posicion: any = this.PositionTop,
      customClass: any = this.customClass, animation: boolean = this.animation) {
      Swal.fire({
        position: posicion,
        showConfirmButton: false,
        timer: timeout,
        title: texto,
        toast: true,
        icon: tipo,
        customClass,
        animation,
      });
    }

    public alert(
      titulo: string, texto: string = '', tipo: any = this.TypeSuccess,
      timeout: number = 0, posicion: any = this.PositionCenter,
      customClass: any = this.customClass, animation: boolean = this.animation,
      allowOutsideClick: boolean = this.allowOutsideClick, 
      allowEscapeKey: boolean = this.allowEscapeKey) {
      Swal.fire({
        position: posicion,
        text: texto,
        timer: timeout,
        title: titulo,
        icon: tipo,
        customClass,
        animation,
        allowOutsideClick,
        allowEscapeKey
      });
    }

    public confirm(
      texto: string, titulo = 'Pregunta', cb: (res: boolean) => void,
      customClass: any = this.customClass, animation: boolean = this.animation,
      allowOutsideClick: boolean = this.allowOutsideClick,
      allowEscapeKey: boolean = this.allowEscapeKey) {
      Swal.fire({
        cancelButtonText: i18n.tc('no'),
        confirmButtonText: i18n.tc('Sí'),
        showCancelButton: true,
        text: texto,
        title: titulo,
        icon: this.TypeQuestion,
        customClass,
        animation,
        allowOutsideClick,
        allowEscapeKey
      }).then((result: any) => {
        if (result.value) {
          cb(true);
        } else {
          cb(false);
        }
      });
    }

    public showLoading(customClass: any = this.customClass, 
      allowOutsideClick: boolean = this.allowOutsideClick,
      allowEscapeKeyOnLoading: boolean = this.allowEscapeKeyOnLoading) {
      Swal.fire({
        title: i18n.tc('loading'),
        allowEscapeKey: allowEscapeKeyOnLoading,
        customClass,
        allowOutsideClick,
      });
      Swal.showLoading();
    }

    public hideLoading() {
      Swal.close();
    }
}

export const itiMessageService = new ItiMessageService();
